export default "__VITE_ASSET__BmCbUIEF__"